var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconSelectBoxDownN12 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#434343",
  d: "m8.001 12.197-.166.17L0 4.342l.95-.973L8 10.592l7.05-7.224.95.973-7.835 8.027z"
})));
export default SvgIconSelectBoxDownN12;